/* eslint-disable react/prop-types */
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'

function DeleteAmbassadorDialog({ partner, open, onClose, onConfirm, isPending }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Excluir embaixador</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Tem certeza que deseja excluir o embaixador <strong>{partner?.name}</strong>? Esta ação expira
          imediatamente todos os cupons vinculados a ele (mesmo os ainda válidos) e não pode ser desfeita.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" color="error" onClick={onConfirm} disabled={isPending}>
          Excluir
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteAmbassadorDialog
